import routes from "./routes";
import modules from "./store";

export default { routes, modules };
